import coursesApi from 'Api/axios/courses-api';
import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import { CourseI, CourseReportFilterI } from 'types';

interface Props {
  init?: boolean;
}

const useCourseApi = ({ init = false }: Props = {}) => {
  /**
   * Variable para almacenar todos los cursos disponibles en la
   * base de datos del sistema.
   */
  const [data, setData] = useState<CourseI[]>();

  /**
   * Variable para almacenar el curso obtenido por medio de un id.
   * Utilizado en `fetchCourseById`.
   */
  const [course, setCourse] = useState<CourseI>();

  /**
   * Variable para almacenar el estado de carga de los datos.
   */
  const [loading, setLoading] = useState(false);

  /**
   * Variable para almacenar el estado de un error.
   */
  const [error, setError] = useState<string | null>(null);

  /**
   * Realiza una petición para obtener todos los cursos disponibles en el sistema.
   * Se puede aplicar filtros para obtener un subconjunto de cursos.
   */
  const fetchCourses = async () => {
    setLoading(true);
    const response = await coursesApi.readAll();
    setData(response.data);
    setLoading(false);
    setError(response.error);
  };

  /**
   * Realiza una petición para obtener un curso por medio de su id.
   * @param id - ID del curso a obtener.
   */
  const fetchCourseById = async (id: string) => {
    setLoading(true);
    const response = await coursesApi.readUnique(id);
    setCourse(response.data);
    setLoading(false);
    setError(response.error);
  };

  /**
   * Permite obtener los cursos al inicializar el hook.
   */
  useEffect(() => {
    if (init) {
      fetchCourses();
    }
  }, []);

  return {
    data,
    course,
    loading,
    error,
    fetchCourses,
    fetchCourseById,
  };
};

export default useCourseApi;
